import React, { useEffect } from 'react';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedAttempts } from '../components/FailedAttempts';
import { MechanismSection } from '../components/MechanismSection';
import { ProductStack } from '../components/ProductStack';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferBlock } from '../components/OfferBlock';
import { Footer } from '../components/Footer';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen bg-brand-dark text-brand-text selection:bg-brand-accent selection:text-brand-dark" data-id="element-160">
      <HeroSection data-id="element-161" />
      <ProblemSection data-id="element-162" />
      <FailedAttempts data-id="element-163" />
      <MechanismSection data-id="element-164" />
      <ProductStack data-id="element-165" />
      <AudienceSection data-id="element-166" />
      <HowItWorks data-id="element-167" />
      <ProofSection data-id="element-168" />
      <FAQSection data-id="element-169" />
      <OfferBlock data-id="element-170" />

      <Footer data-id="element-171" />
    </main>;
}